import React, { useEffect } from "react";

type useClickInsideProps = {
  refs: Array<React.RefObject<HTMLDivElement>>;
  handler: (event: Event) => void;
  isDisable?: boolean;
};

const useClickInside = (props: useClickInsideProps) => {
  const { refs = [], handler, isDisable = false } = props;
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isDisable) {
      const listener = (event) => {
        const isClickedOnRef = refs.some((ref) =>
          ref.current?.contains(event.target),
        );
        if (isClickedOnRef) {
          handler(event);
        }
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }
  }, [refs, handler, isDisable]);
};

export default useClickInside;
